export enum RenovationProjectStage {
  AvantTravaux = 0,
  ApresTravaux = 1,
  Dossier = 2
}

export enum CeeProcessingStatus {
  Nouveau = 0,
  EnCours = 1,
  Refuse = 2,
  Incomplet = 3,
  Arbitrage = 4,
  Complet = 5,
  NonControle = 6,
  EnRetour = 7,
  Abandon = 8
}

export enum InternalAuditStatus {
  PreSelectionne = 0,
  AEffectuer = 1,
  Refuse = 2,
  NonSatisfaisant = 3,
  Arbitrage = 4,
  Satisfaisant = 5,
  NonControle = 6
}

export enum ExternalAuditStatus {
  PreSelectionne = 0,
  AEffectuer = 1,
  Refuse = 2,
  NonSatisfaisant = 3,
  Arbitrage = 4,
  Satisfaisant = 5,
  NonControle = 6,
  PartiellementSatisfaisant = 7,
  NonSatisfaisantAttenteSAV = 8,
  NonSatisfaisantSAVEffectue = 9,
  NonSatisfaisantCorrigeAvecCSS = 10,
  InaccessibleNonVerifiable = 11,
  NonEnvoyeAuControle = 12,
    NonSatisfaisantCorrigeSansCSS = 13
}

export enum CssProjectStatus {
  AArbitrer = 0,
  NonConcerne = 1,
  AEffectuer = 2,
  EnCours = 3,
  Refuse = 4,
  Satisfaisant = 5,
  SatisfaisantNonEnvoye = 6,
  EnAttenteSAV = 7,
  SAVEffectue = 8
}

export enum ContactAuditStatus {
  PreSelectionne = 0,
  AEffectuer = 1,
  Refuse = 2,
  NonSatisfaisant = 3,
  Arbitrage = 4,
  Satisfaisant = 5,
  NonControle = 6,
  InformationsManquantes = 7,
  NonSatisfaisantAttenteSAV = 8,
  NonSatisfaisantSAVAValider = 9,
  NonSatisfaisantCorrige = 10,
  SatisfaisantSansReponse = 11,
  ContreAppelEnCours = 12,
  FauxNumero = 13,
  NeSouhaitePasRepondre = 14,
  ValideCofrac = 15,
  EnSav = 16
}

export enum EmmyStatus {
  Envoye = 0,
  Valide = 1,
  Refuse = 2
}

export enum DovaStatus {
  EnAttente = 0,
  EnCours = 1,
  Termine = 2,
  Abandonne = 3,
  EchecTraitement = 4,
  EchecConversion = 5,
  ReponseVide = 6,
  ConversionEnCours = 7
}

export enum PaperAuditStatus {
  NonRecu = 0,
  Recu = 1,
  Incomplet = 2,
  Complet = 3
}

export enum PhoneAuditStatus {
  PreSelectionne = 0,
  AEffectuer = 1,
  Refuse = 2,
  NonSatisfaisant = 3,
  Arbitrage = 4,
  Satisfaisant = 5,
  NonControle = 6,
  PartiellementSatisfaisant = 7,
  NonSatisfaisantRetourPartenaire = 8,
  NonSatisfaisantPiecesChargees = 9,
  NonSatisfaisantCorrige = 10
}

export enum MprProcessingStatus {
  Nouveau = 0,
  EnCours = 1,
  Refuse = 2,
  IncompletACE = 3,
  Arbitrage = 4,
  PrimeADemander = 5,
  EnAttenteValidation = 6,
  EnAttenteDossierCEE = 7,
  FactureChargee = 8,
  SoldeADemander = 9,
  EnAttenteSolde = 10,
  SoldeRecu = 11
}

export enum ExternalAuditBatchStatus {
  Nouveau = 0,
  Emis = 1,
  SyntheseRecue = 2,
  Cloture = 3,
  Abandon = 4
}

// Status card keys enum for type safety
export enum BatchStatusKey {
  Nouveau = 0,
  Emis = 1,
  SyntheseRecue = 2,
  Cloture = 3,
  Abandonne = 4,
  EnAttenteSAV = 5,
  SAVEffectues = 6,
  ACloturer = 7,
  Tous = 8
}

export enum BatchType {
  Obligatoire = 0,
  Facultatif = 1,
  Simple = 2,
  Double = 3
}
